import { useState, useEffect } from 'react'
import { Form, Field, Button, Toast } from 'react-vant'
import { UserO, Lock } from '@react-vant/icons'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { loginAsync } from '../../store/userSlice'
import { getPublicSchoolInfo } from '../../api/school'
import './style.css'

export default function Login() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [schoolInfo, setSchoolInfo] = useState({ schoolName: '体育教学辅助系统', logoUrl: null })

  // 获取学校公用信息
  useEffect(() => {
    const fetchSchoolInfo = async () => {
      try {
        const res = await getPublicSchoolInfo()
        if (res) {
          setSchoolInfo({
            schoolName: res.schoolName || '体育教学辅助系统',
            logoUrl: res.logoUrl
          })
        }
      } catch (error) {
        console.error('获取学校信息失败:', error)
      }
    }
    fetchSchoolInfo()
  }, [])

  // 登录
  const handleLogin = async () => {
    if (!username || !password) {
      Toast.fail('请填写用户名和密码')
      return
    }
    setLoading(true)
    try {
      const resultAction = await dispatch(loginAsync({ username, password }))
      if (loginAsync.fulfilled.match(resultAction)) {
        const result = resultAction.payload
        Toast.success('登录成功')

        // 根据角色跳转
        if (result.userInfo.role === 'admin') {
          navigate('/admin', { replace: true })
        } else if (result.userInfo.role === 'teacher') {
          navigate('/', { replace: true })
        } else {
          navigate('/student', { replace: true })
        }
      } else {
        Toast.fail(resultAction.payload || '登录失败')
      }
    } catch (error) {
      Toast.fail('系统错误')
    } finally {
      setLoading(false)
    }
  }

  // 拼接图片地址
  const getFullImageUrl = (url) => {
    if (!url) return null
    if (url.startsWith('http')) return url
    const baseUrl = import.meta.env.VITE_API_BASE_URL || '/api'
    // 健壮性处理：如果 baseUrl 是绝对路径，安全地利用 URL 属性提取其 origin，以防域名中包含 'api'（例如 api.d2ty.cn）导致 split('/api') 误切
    if (baseUrl.startsWith('http')) {
      try {
        const urlObj = new URL(baseUrl)
        return `${urlObj.origin}${url}`
      } catch (e) {
        // 降级回退
      }
    }
    const rootUrl = baseUrl.split('/api')[0]
    return `${rootUrl}${url}`
  }

  return (
    <div className="login-page">
      {/* 动态背景层 */}
      <div className="login-bg-liquid" />
      <div className="login-bg-grid" />

      <div className="login-content">
        <header className="login-header">
          {schoolInfo.logoUrl && (
            <div className="school-logo-wrapper">
              <img
                src={getFullImageUrl(schoolInfo.logoUrl)}
                alt="School Logo"
                className="school-logo"
              />
            </div>
          )}
          <h1>{schoolInfo.schoolName}</h1>
          <p>SPORTS MANAGEMENT SYSTEM</p>
        </header>

        <div className="glass-login-card">
          <Form
            onFinish={handleLogin}
            footer={
              <div style={{ margin: '16px 16px 0' }}>
                <Button
                  round
                  nativeType="submit"
                  type="primary"
                  block
                  loading={loading}
                  className="login-btn"
                >
                  登 录
                </Button>
              </div>
            }
          >
            <div className="login-form">
              <div className="form-item">
                <Field
                  value={username}
                  onChange={setUsername}
                  placeholder="请输入用户名"
                  leftIcon={<UserO />}
                  type="text"
                  border={false}
                  rules={[{ required: true, message: '请输入用户名' }]}
                />
              </div>

              <div className="form-item">
                <Field
                  value={password}
                  onChange={setPassword}
                  placeholder="请输入密码"
                  leftIcon={<Lock />}
                  type="password"
                  border={false}
                  rules={[{ required: true, message: '请输入密码' }]}
                />
              </div>
            </div>
          </Form>

          <footer className="login-tips">
            <p>教师/内部员工请使用分配的账号登录</p>
            <p>家长请使用学生8位数字的教育ID进行登录</p>
          </footer>
        </div>
      </div>
    </div>
  )
}
